export default __webpack_public_path__ + "static/media/finishImg.a3036170.png";